var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "company-profile"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('div', {
    staticClass: "card-header"
  }, [(_vm.companyaction == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Add Company")]) : _vm._e(), _vm._v(" "), (_vm.companyaction == 'edit') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Edit Company")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Company Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('companyname')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Company Name",
      "name": "companyname",
      "id": "companyname"
    },
    model: {
      value: (_vm.addcompany.companyname),
      callback: function($$v) {
        _vm.addcompany.companyname = $$v
      },
      expression: "addcompany.companyname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('companyname')),
      expression: "errors.has('companyname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Company Name field is required.\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Company Person Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('companypersonname')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Company Person Name",
      "name": "companypersonname",
      "id": "companypersonname"
    },
    model: {
      value: (_vm.addcompany.companypersonname),
      callback: function($$v) {
        _vm.addcompany.companypersonname = $$v
      },
      expression: "addcompany.companypersonname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('companypersonname')),
      expression: "errors.has('companypersonname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Person Name field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Company Person Email ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "placeholder": "Enter Email Address",
      "name": "email",
      "id": "companypersonemail"
    },
    model: {
      value: (_vm.addcompany.companypersonemail),
      callback: function($$v) {
        _vm.addcompany.companypersonemail = $$v
      },
      expression: "addcompany.companypersonemail"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1)], 1)])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Address1")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-address-card'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('companyaddress')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Address",
      "name": "companyaddress",
      "id": "companyaddress"
    },
    model: {
      value: (_vm.addcompany.companyaddress),
      callback: function($$v) {
        _vm.addcompany.companyaddress = $$v
      },
      expression: "addcompany.companyaddress"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('companyaddress')),
      expression: "errors.has('companyaddress')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Address field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Address2")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('companyaddress2')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Address2",
      "name": "companyaddress2",
      "id": "companyaddress2"
    },
    model: {
      value: (_vm.addcompany.companyaddress2),
      callback: function($$v) {
        _vm.addcompany.companyaddress2 = $$v
      },
      expression: "addcompany.companyaddress2"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('companyaddress2')),
      expression: "errors.has('companyaddress2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('companyaddress2')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-flag'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('country')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Country",
      "name": "country",
      "id": "country"
    },
    model: {
      value: (_vm.addcompany.country),
      callback: function($$v) {
        _vm.addcompany.country = $$v
      },
      expression: "addcompany.country"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('country')),
      expression: "errors.has('country')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Country field is required.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addcompany.companystate),
      expression: "addcompany.companystate"
    }],
    staticClass: "form-control",
    on: {
      "click": _vm.getCityList,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addcompany.companystate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a State")]), _vm._v(" "), _vm._l((_vm.listStateData), function(state_obj) {
    return _c('option', [_vm._v(_vm._s(state_obj.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state')),
      expression: "errors.has('state')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The State field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-city'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addcompany.city),
      expression: "addcompany.city"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addcompany.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a City")]), _vm._v(" "), _vm._l((_vm.listCityData), function(city_obj) {
    return _c('option', [_vm._v(_vm._s(city_obj.city_name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The City field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("PIN Code")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max:6'),
      expression: "'required|numeric|max:6'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('pincode')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter PIN Code",
      "name": "pincode",
      "id": "pincode"
    },
    model: {
      value: (_vm.addcompany.pincode),
      callback: function($$v) {
        _vm.addcompany.pincode = $$v
      },
      expression: "addcompany.pincode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Company Person Mobile Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max:10'),
      expression: "'required|numeric|max:10'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('mobile_number')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Mobile Number",
      "name": "mobile number",
      "id": "mobile"
    },
    model: {
      value: (_vm.addcompany.companypersonmobile),
      callback: function($$v) {
        _vm.addcompany.companypersonmobile = $$v
      },
      expression: "addcompany.companypersonmobile"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobile number')),
      expression: "errors.has('mobile number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('mobile number')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Company Person Phone Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max:6'),
      expression: "'required|numeric|max:6'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('phone_number')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Phone Number",
      "name": "phone number",
      "id": "companypersonphone"
    },
    model: {
      value: (_vm.addcompany.companypersonphone),
      callback: function($$v) {
        _vm.addcompany.companypersonphone = $$v
      },
      expression: "addcompany.companypersonphone"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone number')),
      expression: "errors.has('phone number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone number')))])], 1)], 1)])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Company Registration Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-registered'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('companyregisternum')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Registration Number",
      "name": "company registernum",
      "id": "companyregisternum"
    },
    model: {
      value: (_vm.addcompany.companyregisternum),
      callback: function($$v) {
        _vm.addcompany.companyregisternum = $$v
      },
      expression: "addcompany.companyregisternum"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('company registernum')),
      expression: "errors.has('company registernum')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('company registernum')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Company PAN Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-drivers-license'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('companypanid')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Pan Id",
      "name": "company panid",
      "id": "company panid"
    },
    model: {
      value: (_vm.addcompany.companypanid),
      callback: function($$v) {
        _vm.addcompany.companypanid = $$v
      },
      expression: "addcompany.companypanid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('company panid')),
      expression: "errors.has('company panid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('company panid')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Company GST Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('companygstnum')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter GST Number",
      "name": "company gstnum",
      "id": "company gst num"
    },
    model: {
      value: (_vm.addcompany.companygstnum),
      callback: function($$v) {
        _vm.addcompany.companygstnum = $$v
      },
      expression: "addcompany.companygstnum"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('company gst num')),
      expression: "errors.has('company gst num')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('company gst num')))])], 1)], 1)])]), _vm._v(" "), _c('fieldset'), _vm._v(" "), _c('div', {
    staticClass: "companyfooter form-actions"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.saveCompany
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "secondary"
    }
  }, [_vm._v("Cancel")])], 1)])], 1)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45c021cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c021cb","hasScoped":true}!./src/views/components/companyProfile/companyProfile.component.html
// module id = 1069
// module chunks = 0